export default {
  files: [
    {
      id: "2",
      name: "Sanchez Fixture Schedule",
      capabilities: { canEdit: true }
    }
  ]
}



/** WEBPACK FOOTER **
 ** ./src/js/clients/mock/fixtures/term_folders/0B7M38pRihZntUThVLXlqdFdxdDQ.js
 **/